module.exports = __webpack_public_path__ + "static/img/2.0653ba6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/2.png
// module id = 82jU
// module chunks = 0